import React from 'react';
import * as S from './NoBookingCard.styles';

import IconSelector from '@ibibo/icon-selector';

const NoBookingCard = ({tab, navigateToHotels, showButton}) => {
    return(
        <S.NoBookingCardOuterWrap>
          <S.NoBkngImgWrap>
            <IconSelector iconKey={`${tab}empty`} />
          </S.NoBkngImgWrap>
          <S.NoBookingInfoText>
            <S.NoBookingHeadText>Looks empty, you've no {tab || ''} bookings.</S.NoBookingHeadText>
            <S.NoBookingSubText>When you book a trip, you will see your itinerary here.</S.NoBookingSubText>
            {(showButton && <S.NoBookingBtnWrap onClick={navigateToHotels}>
              <S.PlanTripBtn>Plan a trip</S.PlanTripBtn>
            </S.NoBookingBtnWrap>) || null}
          </S.NoBookingInfoText>
        </S.NoBookingCardOuterWrap>
    );
}

export default NoBookingCard;